import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'scHideFractionPart',
})
export class HideFractionPartPipe implements PipeTransform {
  transform(value: string | number): string {
    return typeof value === 'number'
      ? value.toString().split('.')[0]
      : value.split('.')[0];
  }
}
